export default "__VITE_ASSET__Hjf9RTxb__"